import styled, { keyframes } from 'styled-components';
import colors from '../../assets/styles/colors';

const loading = keyframes`
  from {
    width: 0%;
  }

  to {
    width: 100%;
  }
`;

export const InputFileLoadingContent = styled.div`
  position: relative;
  min-height: ${props => props.rotatedHeight * 1.15}px;
  border-radius: 8px;
  background: ${colors.white};
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  align-items: center;
  justify-content: center;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    animation: ${loading} forwards 2s normal;
    height: 100%;
    background: ${colors.bgSecondaryLight};
    border-radius: 8px;
  }

  & > svg {
    cursor: pointer;
    position: relative;
    z-index: 99;
  }
`;

export const DivForSearchAndRotate = styled.div`
  position: relative;
  width: 100%;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;


export const InputFileLoadingDocumentInfo = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  z-index: 99;
  padding-top: 50px;
`;

export const InputFileLoadingDocumentInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const BackImg = styled.img`
 
`;

export const ImageContainer = styled.div`
  position: relative;
  text-align: center;
`;

export const FrontImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.2;
  max-height: 100%
`;

export const InputFileLoadingDocumentInfoText = styled.span`
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.03em;
  color: ${colors.white};
`;
